import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as actionCreators from "../../../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Discount from "../../../Components/Discount";
import "./styles.css";

function ItemMenu({
  id,
  codcia,
  selectMenu,
  value,
  icon,
  title,
  active,
  haveDiscount,
  discount,
  msgpde,
  disabled
}) {
  return (
    <div
      key={id}
      className={`mn-item ${active ? "active" : ""}`}
      onClick={() => {
        !disabled && selectMenu({ value, id, codcia, haveDiscount, msgpde });
      }}
    >
      {/* {haveDiscount && <Discount discount={discount} />} */}
      <div className={`iconoMn`}>
        <img src={icon} />
      </div>
      <span>{title}</span>
      {haveDiscount ? (
        <span className="discount">{discount} % OFF</span>
      ) : (
        <span style={{color: active ? "#e6e6e6" : "white"}}>%</span>
      )}
    </div>
  );
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(null, mapDispatchToProps)(ItemMenu);
